import { memo, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { When } from 'react-if';

import classNames from 'classnames';
import './Element.scss';

const isOpenInNewTab = e => e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1

const Element = ({ expanded, animationStarted, icon, text, onClick, selected, path = undefined, tooltipText = undefined, ...props }) => {
  const onClickLocal = useCallback(e => {
    if(isOpenInNewTab(e)) {
      return
    }
    e.preventDefault()
    e.stopPropagation()
    onClick(path)
  }, [path, onClick]),
  [showTooltip, setShowTooltip] = useState(),
  onMouseEnter = useCallback(() => setShowTooltip(true), []),
  onMouseLeave = useCallback(() => setShowTooltip(false), [])

  useEffect(() => {
    if(expanded) {
      setShowTooltip(false)
    }
  }, [expanded])

  return (
    <a
        {...props}
        className={classNames(
          "sidebar__group__element",
          { "sidebar__group__element--is-selected": selected }
        )}
        href={path}
        onClick={onClickLocal}
        onMouseEnter={tooltipText ? onMouseEnter : undefined}
        onMouseLeave={tooltipText ? onMouseLeave : undefined}
    >
      <div className="sidebar__group__element__bg"/>
      <div className="sidebar__group__element__icon">
        {icon}
      </div>
      <When condition={showTooltip}>
        {() => (
          <div className="sidebar__group__element__tooltip">
            <div className="sidebar__group__element__tooltip__icon">{icon}</div>
            <div className="sidebar__group__element__tooltip__text">{tooltipText}</div>
          </div>
        )}
      </When>
      <When condition={expanded && !animationStarted}>
        {() => (
          <div className="sidebar__group__element__text">
            {text}
          </div>
        )}
      </When>
    </a>
  )
}

Element.propTypes = {
  animationStarted: PropTypes.bool.isRequired,
  expanded: PropTypes.bool.isRequired,
  icon: PropTypes.element.isRequired,
  onClick: PropTypes.func.isRequired,
  path: PropTypes.string,
  selected: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  tooltipText: PropTypes.string
}

export default memo(Element);